module.exports = __webpack_public_path__ + "img/persen_attestation.15b5c9f4.png";